import { getApiClient } from '../utils/apiClient';
let qualityApiBase = 'marketplace/quality/customer/v1';
const qualityAdminApiBase = 'marketplace/quality/v1';
export const setQualityApiBase = base => {
  qualityApiBase = base;
};
export const fetchCollectionItems = (collectionId, query, isAdminPreview) => {
  const apiBase = isAdminPreview ? qualityAdminApiBase : qualityApiBase;
  return getApiClient().get(`${apiBase}/self-serve/apps/collections/${collectionId}/items`, {
    query
  });
};
export const reportReview = ({
  reviewId,
  reportReason,
  comment
}) => getApiClient().post(`${qualityApiBase}/reviews/${reviewId}/report`, {
  data: {
    reportReason,
    comment
  }
});
export const reportReply = ({
  reviewId,
  replyId,
  reportReason,
  comment
}) => getApiClient().post(`${qualityApiBase}/reviews/${reviewId}/replies/${replyId}/report`, {
  data: {
    reportReason,
    comment
  }
});